"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _atoms = require("../../atoms");

var _jsxRuntime = require("react/jsx-runtime");

var Footer = function Footer(_ref) {
  var children = _ref.children;
  return (0, _jsxRuntime.jsx)(_atoms.Flex, {
    height: {
      _: 'auto',
      lg: '300px'
    },
    flexDirection: {
      _: 'column',
      lg: 'row'
    },
    justifyContent: "center",
    alignItems: "center",
    padding: {
      _: '40px 30px',
      lg: '40px 50px',
      xl: '40px 115px'
    },
    backgroundColor: "secondary",
    children: children
  });
};

exports.Footer = Footer;